// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================================================
   SAFFRON OS – ORGANIC SEARCH WITH AI, GEO ETC  |  Modern AI-Native Design System
   ================================================================ */

:root {
  /* Brand palette */
  --saffron: #f59e0b;
  --saffron-light: #fbbf24;
  --saffron-glow: rgba(245, 158, 11, 0.2);

  /* Teal accents */
  --teal: #0891b2;
  --teal-bright: #06b6d4;
  --teal-glow: rgba(6, 182, 212, 0.18);
  --teal-glow-strong: rgba(6, 182, 212, 0.35);

  /* Backgrounds */
  --bg-base: #08111f;
  --bg-elevated: #0d1829;
  --bg-card: rgba(13, 24, 41, 0.82);
  --bg-card-hover: rgba(13, 24, 41, 0.97);
  --bg-input: rgba(8, 17, 31, 0.75);
  --bg-overlay: rgba(0, 0, 0, 0.72);

  /* Borders */
  --border: rgba(255, 255, 255, 0.07);
  --border-hover: rgba(6, 182, 212, 0.32);
  --border-focus: rgba(6, 182, 212, 0.55);

  /* Text */
  --text: #e2e8f0;
  --text-secondary: #94a3b8;
  --text-muted: #64748b;
  --text-heading: #f8fafc;

  /* Status colors */
  --success: #10b981;
  --success-bg: rgba(16, 185, 129, 0.1);
  --success-border: rgba(16, 185, 129, 0.28);
  --warning: #f59e0b;
  --warning-bg: rgba(245, 158, 11, 0.1);
  --warning-border: rgba(245, 158, 11, 0.28);
  --danger: #ef4444;
  --danger-bg: rgba(239, 68, 68, 0.1);
  --danger-border: rgba(239, 68, 68, 0.28);
  --info: #3b82f6;
  --info-bg: rgba(59, 130, 246, 0.1);
  --info-border: rgba(59, 130, 246, 0.28);

  /* Gradients */
  --gradient-brand: linear-gradient(135deg, #06b6d4 0%, #f59e0b 100%);
  --gradient-teal: linear-gradient(135deg, #0891b2, #06b6d4);
  --gradient-btn: linear-gradient(135deg, #0891b2 0%, #0e7490 100%);

  /* Shadows */
  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.35);
  --shadow-md: 0 4px 24px rgba(0, 0, 0, 0.45);
  --shadow-lg: 0 12px 48px rgba(0, 0, 0, 0.55);
  --shadow-glow-teal: 0 0 24px rgba(6, 182, 212, 0.12);

  /* Surface — used for cards, list items, panels */
  --surface: #0d1829;
  --bg: var(--bg-base);
  --text-primary: #f8fafc;

  /* Legacy compat aliases used inline in JSX */
  --primary: #0891b2;
  --primary-light: #06b6d4;
  --secondary: #06b6d4;
  --light: #e2e8f0;
  --lighter: rgba(255, 255, 255, 0.04);
  --dark: #f8fafc;
}

/* ================================================================
   RESET & BASE
   ================================================================ */

*,
*::before,
*::after {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

body {
  font-family:
    "Inter",
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    Roboto,
    sans-serif;
  background-color: var(--bg-base);
  color: var(--text);
  line-height: 1.6;
  -webkit-font-smoothing: antialiased;
  min-height: 100vh;
  overflow-x: hidden;
}

/* ================================================================
   ATMOSPHERIC BACKGROUND
   ================================================================ */

body::before {
  content: "";
  position: fixed;
  inset: 0;
  background:
    radial-gradient(
      ellipse 90% 55% at 15% 25%,
      rgba(6, 182, 212, 0.055) 0%,
      transparent 65%
    ),
    radial-gradient(
      ellipse 65% 45% at 85% 75%,
      rgba(245, 158, 11, 0.045) 0%,
      transparent 65%
    ),
    radial-gradient(
      ellipse 110% 80% at 50% 5%,
      rgba(8, 145, 178, 0.035) 0%,
      transparent 70%
    );
  pointer-events: none;
  z-index: 0;
  animation: atmos-drift 20s ease-in-out infinite alternate;
}

@keyframes atmos-drift {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

body::after {
  content: "";
  position: fixed;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.022) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.022) 1px, transparent 1px);
  background-size: 44px 44px;
  pointer-events: none;
  z-index: 0;
}

#root {
  position: relative;
  z-index: 1;
}

/* ================================================================
   LAYOUT
   ================================================================ */

.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 28px;
}

.dashboard-description {
  background: transparent;
  border: none;
  border-radius: 0;
  padding: 0;
  margin-bottom: 20px;

  font-size: 12px;
  line-height: 1.7;
  color: rgb(167, 167, 167);
  font-weight: 100;
}

.full-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.page {
  padding: 36px 0;
  min-height: calc(100vh - 68px);
}

/* ================================================================
   HEADER
   ================================================================ */

.header {
  background: rgba(8, 17, 31, 0.88);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border-bottom: 1px solid var(--border);
  padding: 0;
  height: 68px;
  position: sticky;
  top: 0;
  z-index: 200;
  box-shadow:
    0 1px 0 rgba(255, 255, 255, 0.04),
    0 4px 32px rgba(0, 0, 0, 0.35);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 28px;
  height: 100%;
}

.logo {
  display: flex;
  align-items: center;
  gap: 14px;
  text-decoration: none;
}

.logo-img {
  height: 36px;
  width: auto;
  filter: brightness(1.1) drop-shadow(0 0 8px rgba(6, 182, 212, 0.25));
}

.logo span {
  font-size: 15px;
  font-weight: 700;
  letter-spacing: -0.01em;
  background: var(--gradient-brand);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 16px;
}

.user-info > span {
  font-size: 13px;
  color: var(--text-secondary);
  font-weight: 500;
}

/* Mobile three-dot menu — hidden on desktop */
.mobile-menu-wrap {
  display: none;
  position: relative;
}

.mobile-menu-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 4px;
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
  padding: 0;
  flex-shrink: 0;
}

.mobile-menu-btn span {
  display: block;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--text-secondary);
}

.mobile-menu-dropdown {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  min-width: 200px;
  background: rgba(8, 17, 31, 0.98);
  backdrop-filter: blur(24px);
  -webkit-backdrop-filter: blur(24px);
  border: 1px solid var(--border);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  overflow: hidden;
  z-index: 300;
}

.mobile-menu-user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid var(--border);
}

.mobile-menu-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--gradient-btn);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  color: white;
  flex-shrink: 0;
}

.mobile-menu-username {
  font-size: 13px;
  font-weight: 500;
  color: var(--text-secondary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mobile-menu-signout {
  display: block;
  width: 100%;
  padding: 12px 16px;
  text-align: left;
  font-size: 13px;
  font-weight: 500;
  color: #f87171;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background 0.15s ease;
}

.mobile-menu-signout:hover {
  background: rgba(239, 68, 68, 0.08);
}

/* ================================================================
   CARDS & PANELS
   ================================================================ */

.card {
  background: var(--bg-card);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 24px;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.card:hover {
  background: var(--bg-card-hover);
  border-color: var(--border-hover);
  box-shadow: var(--shadow-md), var(--shadow-glow-teal);
  transform: translateY(-2px);
}

.card-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 20px;
  margin: 20px 0;
}

/* ================================================================
   FORMS
   ================================================================ */

.form-group {
  margin-bottom: 18px;
}

.form-group label {
  display: block;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: var(--text-secondary);
  margin-bottom: 8px;
}

.form-group input,
.form-group select,
.form-group textarea {
  width: 100%;
  padding: 11px 14px;
  background: var(--bg-input);
  border: 1px solid var(--border);
  border-radius: 8px;
  font-size: 14px;
  font-family: "Inter", inherit;
  color: var(--text);
  transition: all 0.2s ease;
  outline: none;
}

.form-group input::placeholder,
.form-group textarea::placeholder {
  color: var(--text-muted);
}

.form-group select option {
  background: var(--bg-elevated);
  color: var(--text);
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  border-color: var(--border-focus);
  box-shadow:
    0 0 0 3px var(--teal-glow),
    0 0 16px var(--teal-glow);
  background: rgba(8, 17, 31, 0.92);
}

/* ================================================================
   BUTTONS
   ================================================================ */

.btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  font-family: "Inter", inherit;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;
  position: relative;
  overflow: hidden;
  white-space: nowrap;
  letter-spacing: 0.01em;
}

.btn:active {
  transform: scale(0.97);
}
.btn:disabled {
  opacity: 0.42;
  cursor: not-allowed;
  transform: none !important;
}

.btn-primary {
  background: var(--gradient-btn);
  color: white;
  box-shadow: 0 2px 14px rgba(8, 145, 178, 0.28);
}

.btn-primary:hover:not(:disabled) {
  box-shadow: 0 4px 22px rgba(6, 182, 212, 0.42);
  transform: translateY(-1px);
}

.btn-secondary {
  background: linear-gradient(135deg, #0891b2, #06b6d4);
  color: white;
  box-shadow: 0 2px 14px rgba(6, 182, 212, 0.22);
}

.btn-secondary:hover:not(:disabled) {
  box-shadow: 0 4px 22px rgba(6, 182, 212, 0.42);
  transform: translateY(-1px);
}

.btn-success {
  background: linear-gradient(135deg, #059669, #10b981);
  color: white;
}

.btn-danger {
  background: linear-gradient(135deg, #dc2626, #ef4444);
  color: white;
}

.btn-small {
  padding: 6px 12px;
  font-size: 12px;
  border-radius: 6px;
}
.btn-full {
  width: 100%;
}

/* ================================================================
   BADGES
   ================================================================ */

.badge {
  display: inline-flex;
  align-items: center;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}

.badge-success {
  background: var(--success-bg);
  color: #34d399;
  border: 1px solid var(--success-border);
}

.badge-warning {
  background: var(--warning-bg);
  color: #fbbf24;
  border: 1px solid var(--warning-border);
}

.badge-danger {
  background: var(--danger-bg);
  color: #f87171;
  border: 1px solid var(--danger-border);
}

.badge-info {
  background: var(--info-bg);
  color: #60a5fa;
  border: 1px solid var(--info-border);
}

.badge-category {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  background: rgba(6, 182, 212, 0.08);
  color: var(--teal-bright);
  border: 1px solid rgba(6, 182, 212, 0.18);
  padding: 3px 10px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 500;
  margin-top: 8px;
}

/* ================================================================
   TABLES
   ================================================================ */

.table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin: 12px 0;
}

.table th {
  background: rgba(255, 255, 255, 0.025);
  padding: 12px 16px;
  text-align: left;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
  color: var(--text-secondary);
  border-bottom: 1px solid var(--border);
}

.table td {
  padding: 14px 16px;
  border-bottom: 1px solid var(--border);
  font-size: 13px;
  color: var(--text);
  vertical-align: middle;
}

.table tbody tr {
  transition: background 0.15s ease;
}
.table tbody tr:hover {
  background: rgba(6, 182, 212, 0.04);
}
.table tbody tr:last-child td {
  border-bottom: none;
}

/* ================================================================
   MODAL
   ================================================================ */

.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.72);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  animation: fadeIn 0.18s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.modal {
  background: rgba(8, 17, 31, 0.97);
  backdrop-filter: blur(28px);
  -webkit-backdrop-filter: blur(28px);
  border: 1px solid var(--border);
  border-radius: 18px;
  box-shadow:
    var(--shadow-lg),
    0 0 80px rgba(6, 182, 212, 0.07);
  max-width: 560px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  animation: slideUp 0.28s cubic-bezier(0.34, 1.4, 0.64, 1);
  position: relative;
}

.modal::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(6, 182, 212, 0.5),
    rgba(245, 158, 11, 0.35),
    transparent
  );
  border-radius: 18px 18px 0 0;
  z-index: 1;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(24px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.modal-header {
  padding: 22px 26px;
  border-bottom: 1px solid var(--border);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-header h2 {
  font-size: 17px;
  font-weight: 600;
  color: var(--text-heading);
  display: flex;
  align-items: center;
  gap: 10px;
}

.modal-body {
  padding: 26px;
}

.modal-footer {
  padding: 18px 26px;
  border-top: 1px solid var(--border);
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  background: rgba(0, 0, 0, 0.18);
  border-radius: 0 0 18px 18px;
}

.close-btn {
  background: rgba(255, 255, 255, 0.055);
  border: 1px solid var(--border);
  border-radius: 7px;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 15px;
  cursor: pointer;
  color: var(--text-secondary);
  transition: all 0.15s ease;
  line-height: 1;
  flex-shrink: 0;
}

.close-btn:hover {
  background: rgba(239, 68, 68, 0.14);
  border-color: rgba(239, 68, 68, 0.3);
  color: #f87171;
}

/* ================================================================
   STATUS INDICATORS
   ================================================================ */

.status-container {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 16px 20px;
  background: rgba(6, 182, 212, 0.05);
  border: 1px solid rgba(6, 182, 212, 0.14);
  border-radius: 10px;
  margin: 15px 0;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(6, 182, 212, 0.14);
  border-top-color: var(--teal-bright);
  border-radius: 50%;
  animation: spin 0.75s linear infinite;
  flex-shrink: 0;
}

.spinner-center {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 64px;
  flex-direction: column;
  gap: 20px;
}

.spinner-lg {
  width: 42px;
  height: 42px;
  border: 3px solid rgba(6, 182, 212, 0.1);
  border-top-color: var(--teal-bright);
  border-right-color: rgba(6, 182, 212, 0.45);
  border-radius: 50%;
  animation: spin 0.9s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.pulse-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: var(--teal-bright);
  position: relative;
  flex-shrink: 0;
  box-shadow: 0 0 8px var(--teal-bright);
}

.pulse-dot::after {
  content: "";
  position: absolute;
  inset: -5px;
  border-radius: 50%;
  border: 2px solid var(--teal-bright);
  animation: pulse-ring 1.6s ease-out infinite;
}

@keyframes pulse-ring {
  0% {
    opacity: 0.8;
    transform: scale(1);
  }
  100% {
    opacity: 0;
    transform: scale(2.2);
  }
}

/* ================================================================
   ALERTS
   ================================================================ */

.alert {
  padding: 12px 16px;
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  border: 1px solid;
}

.alert-success {
  background: var(--success-bg);
  color: #34d399;
  border-color: var(--success-border);
}
.alert-error {
  background: var(--danger-bg);
  color: #f87171;
  border-color: var(--danger-border);
}
.alert-info {
  background: var(--info-bg);
  color: #60a5fa;
  border-color: var(--info-border);
}

/* ================================================================
   TERMINAL WINDOW
   ================================================================ */

.terminal-window {
  background: #020c18;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 16px;
}

.terminal-chrome {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 14px;
  background: rgba(255, 255, 255, 0.025);
  border-bottom: 1px solid rgba(255, 255, 255, 0.055);
}

.term-dot {
  width: 11px;
  height: 11px;
  border-radius: 50%;
}
.term-dot-red {
  background: #ff5f57;
}
.term-dot-yellow {
  background: #ffbd2e;
}
.term-dot-green {
  background: #28c840;
}

.terminal-label {
  margin-left: 8px;
  font-size: 11px;
  color: var(--text-muted);
  font-family: "JetBrains Mono", monospace;
}

.terminal-body {
  padding: 16px 18px;
  font-family: "JetBrains Mono", monospace;
  font-size: 12px;
  height: 300px;
  overflow-y: auto;
  line-height: 1.75;
  color: #c9d1d9;
}

.terminal-body::-webkit-scrollbar {
  width: 4px;
}
.terminal-body::-webkit-scrollbar-track {
  background: transparent;
}
.terminal-body::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.1);
  border-radius: 2px;
}

.log-stderr {
  color: #f87171;
}
.log-stdout {
  color: #c9d1d9;
}
.log-waiting {
  color: var(--text-muted);
  font-style: italic;
}

/* ================================================================
   LOGIN PAGE
   ================================================================ */

.login-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(90px);
  pointer-events: none;
  animation: orb-drift 10s ease-in-out infinite alternate;
}

@keyframes orb-drift {
  0% {
    transform: translate(0, 0) scale(1);
  }
  100% {
    transform: translate(18px, -22px) scale(1.08);
  }
}

.login-card {
  background: rgba(8, 17, 31, 0.88);
  backdrop-filter: blur(36px);
  -webkit-backdrop-filter: blur(36px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 22px;
  padding: 44px 40px 40px;
  width: 100%;
  max-width: 430px;
  position: relative;
  box-shadow:
    0 28px 80px rgba(0, 0, 0, 0.6),
    0 0 50px rgba(6, 182, 212, 0.06);
  animation: slideUp 0.38s cubic-bezier(0.34, 1.3, 0.64, 1);
}

.login-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(6, 182, 212, 0.55),
    rgba(245, 158, 11, 0.42),
    transparent
  );
  border-radius: 22px 22px 0 0;
}

.login-ai-badge {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  padding: 5px 14px;
  background: rgba(6, 182, 212, 0.08);
  border: 1px solid rgba(6, 182, 212, 0.2);
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
  color: var(--teal-bright);
  letter-spacing: 0.06em;
  text-transform: uppercase;
  margin-bottom: 22px;
}

.login-ai-badge::before {
  content: "";
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--teal-bright);
  box-shadow: 0 0 6px var(--teal-bright);
  animation: pulse-dot-anim 2s ease-in-out infinite;
}

@keyframes pulse-dot-anim {
  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    transform: scale(0.75);
  }
}

/* ================================================================
   DASHBOARD TABS
   ================================================================ */

.tab-strip {
  display: inline-flex;
  gap: 3px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid var(--border);
  border-radius: 10px;
  padding: 4px;
  margin-bottom: 36px;
}

.tab-btn {
  padding: 8px 22px;
  border: none;
  background: transparent;
  border-radius: 7px;
  cursor: pointer;
  font-size: 13px;
  font-weight: 500;
  font-family: "Inter", inherit;
  color: var(--text-secondary);
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;
  letter-spacing: 0.01em;
}

.tab-btn:hover {
  color: var(--text);
  background: rgba(255, 255, 255, 0.05);
}

.tab-btn.tab-active {
  background: var(--gradient-btn);
  color: white;
  box-shadow: 0 2px 14px rgba(8, 145, 178, 0.3);
}

/* ================================================================
   AGENT CARDS
   ================================================================ */

.agent-card {
  background: var(--bg-card);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid var(--border);
  border-radius: 14px;
  padding: 24px;
  cursor: pointer;
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.agent-card::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 70px;
  background: linear-gradient(to top, rgba(6, 182, 212, 0.045), transparent);
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.25s ease;
}

.agent-card:hover {
  border-color: rgba(6, 182, 212, 0.24);
  box-shadow:
    var(--shadow-md),
    0 0 28px rgba(6, 182, 212, 0.1);
  transform: translateY(-3px);
}

.agent-card:hover::after {
  opacity: 1;
}

.agent-icon-wrap {
  width: 50px;
  height: 50px;
  border-radius: 13px;
  background: rgba(6, 182, 212, 0.08);
  border: 1px solid rgba(6, 182, 212, 0.14);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26px;
  margin-bottom: 18px;
  transition: all 0.25s ease;
  flex-shrink: 0;
}

.agent-card:hover .agent-icon-wrap {
  background: rgba(6, 182, 212, 0.14);
  border-color: rgba(6, 182, 212, 0.32);
  box-shadow: 0 0 18px rgba(6, 182, 212, 0.14);
}

.agent-name {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-heading);
  margin-bottom: 8px;
  line-height: 1.3;
}

.agent-desc {
  font-size: 13px;
  color: var(--text-secondary);
  line-height: 1.65;
  margin-bottom: 18px;
  flex: 1 1;
}

.agent-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 16px;
  border-top: 1px solid var(--border);
  margin-top: auto;
  position: relative;
  z-index: 1;
}

.agent-launch-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 7px 14px;
  background: rgba(6, 182, 212, 0.09);
  border: 1px solid rgba(6, 182, 212, 0.2);
  border-radius: 7px;
  font-size: 12px;
  font-weight: 600;
  color: var(--teal-bright);
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: "Inter", inherit;
  letter-spacing: 0.01em;
}

.agent-launch-btn:hover {
  background: rgba(6, 182, 212, 0.18);
  border-color: rgba(6, 182, 212, 0.4);
  box-shadow: 0 0 14px rgba(6, 182, 212, 0.15);
}

.btn-arrow {
  display: inline-block;
  transition: transform 0.2s ease;
}

.agent-card:hover .btn-arrow {
  transform: translateX(3px);
}

/* ================================================================
   CATEGORY HEADER
   ================================================================ */

.category-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 20px;
}

.category-label {
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: var(--text-muted);
  white-space: nowrap;
}

.category-sep {
  flex: 1 1;
  height: 1px;
  background: linear-gradient(90deg, var(--border) 0%, transparent 100%);
}

/* ================================================================
   EMPTY STATE
   ================================================================ */

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 20px;
  text-align: center;
  gap: 10px;
}

.empty-state-icon {
  font-size: 44px;
  opacity: 0.45;
  margin-bottom: 6px;
}
.empty-state-title {
  font-size: 18px;
  font-weight: 600;
  color: var(--text);
}
.empty-state-desc {
  font-size: 14px;
  color: var(--text-secondary);
  max-width: 320px;
}

/* ================================================================
   RESULTS OUTPUT
   ================================================================ */

.results-output {
  background: #020c18;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 10px;
  padding: 18px 20px;
  max-height: 430px;
  overflow: auto;
  font-family: "JetBrains Mono", monospace;
  font-size: 12.5px;
  line-height: 1.75;
  color: #c9d1d9;
  white-space: pre-wrap;
  word-break: break-word;
  margin-bottom: 20px;
}

/* ================================================================
   SCROLLBAR
   ================================================================ */

* {
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.08) transparent;
}
*::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}
*::-webkit-scrollbar-track {
  background: transparent;
}
*::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.09);
  border-radius: 3px;
}
*::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.18);
}

/* ================================================================
   UTILITY CLASSES
   ================================================================ */

.text-center {
  text-align: center;
}
.text-muted {
  color: var(--text-muted);
}

.mb-1 {
  margin-bottom: 10px;
}
.mb-2 {
  margin-bottom: 20px;
}
.mb-3 {
  margin-bottom: 30px;
}
.mt-1 {
  margin-top: 10px;
}
.mt-2 {
  margin-top: 20px;
}
.gap-1 {
  gap: 10px;
}
.gap-2 {
  gap: 20px;
}

.flex {
  display: flex;
}
.flex-center {
  display: flex;
  align-items: center;
}
.flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.flex-col {
  display: flex;
  flex-direction: column;
}

.p-3 {
  padding: 20px;
}
.p-4 {
  padding: 30px;
}

/* ================================================================
   RESPONSIVE HELPERS (used by components)
   ================================================================ */

/* Horizontal-scroll wrapper for tables */
.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 14px;
}

/* Chat input row — flexes on desktop, stacks on mobile */
.chat-form-row {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

/* Inputs inside the form row always fill their container */
.chat-form-row input,
.chat-form-row select {
  width: 100%;
  box-sizing: border-box;
}

/* Settings two-column layout */
.settings-layout {
  display: flex;
  gap: 28px;
  align-items: flex-start;
}
.settings-sidebar {
  width: 220px;
  flex-shrink: 0;
}

/* ================================================================
   SITE FOOTER
   ================================================================ */

.site-footer {
  border-top: 1px solid var(--border);
  background: rgba(8, 17, 31, 0.72);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  padding: 18px 0;
  margin-top: 48px;
}

.site-footer-inner {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
}

.site-footer-copy {
  font-size: 12px;
  color: var(--text-muted);
  font-weight: 400;
}

.site-footer-links {
  display: flex;
  align-items: center;
  gap: 10px;
}

.site-footer-link {
  font-size: 12px;
  color: var(--text-muted);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.15s ease;
}

.site-footer-link:hover {
  color: var(--teal-bright);
}

.site-footer-sep {
  color: var(--border);
  font-size: 12px;
  -webkit-user-select: none;
          user-select: none;
}

/* ================================================================
   AGENT PAGE — STICKY BACK BUTTON STRIP
   ================================================================ */

.agent-back-strip {
  position: sticky;
  top: 68px;
  z-index: 100;
}

/* ================================================================
   STICKY TAB STRIP + TAB ROW LAYOUT
   ================================================================ */

.sticky-tab-strip {
  position: sticky;
  top: 68px;
  z-index: 150;
  padding-top: 12px;
}

.tab-strip-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}

/* Tab text label — hidden on narrow phones */
.tab-label {
  /* visible by default */
}

/* ================================================================
   EXECUTION HISTORY — ACTION BUTTON GROUP
   ================================================================ */

.exec-actions {
  display: flex;
  gap: 6px;
  flex-wrap: nowrap;
}

/* ================================================================
   RESPONSIVE — 768 px (tablet / large mobile)
   ================================================================ */

@media (max-width: 768px) {
  /* Layout */
  .container {
    padding: 0 14px;
  }
  .page {
    padding: 18px 0;
  }

  /* Header — single row, compact */
  .header {
    height: auto;
  }
  .header-content {
    padding: 10px 14px;
    height: auto;
    gap: 10px;
  }
  .logo span {
    font-size: 13px;
  }
  .header-logo-text {
    display: none;
  }
  /* UserMenu — hide name text on tablet, keep avatar pill */
  .user-menu-name,
  .user-menu-chevron {
    display: none;
  }

  /* Sticky offsets — corrected header offset for mobile (~56px tall) */
  .sticky-tab-strip,
  .agent-back-strip {
    top: 56px;
  }

  /* Dashboard description — hidden on mobile to save vertical space */
  .dashboard-description {
    display: none;
  }

  /* Execution history action buttons — wrap at tablet */
  .exec-actions {
    flex-wrap: wrap;
    gap: 5px;
  }

  /* Agent cards */
  .card-grid {
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 14px;
  }

  /* Modal */
  .modal {
    width: 96%;
    min-width: unset !important;
    border-radius: 14px;
  }

  /* Tab strip */
  .tab-strip {
    margin-bottom: 20px;
  }
  .tab-btn {
    padding: 7px 14px;
    font-size: 12px;
  }

  /* Login */
  .login-card {
    padding: 28px 20px;
    margin: 12px;
  }

  /* Settings — stack sidebar above form */
  .settings-layout {
    flex-direction: column;
    gap: 16px;
  }
  .settings-sidebar {
    width: 100%;
  }

  /* Onboarding — drop the side rail below the form */
  .onboarding-grid {
    grid-template-columns: minmax(0, 1fr) !important;
  }

  /* Execution history table — horizontal scroll */
  .table-responsive {
    border-radius: 14px;
  }
  /* Hide less-critical columns on tablet */
  .table-col-hide {
    display: none;
  }

  /* Footer */
  .site-footer-inner {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 8px;
    padding: 0 14px;
  }

  /* DataForSEO credential grid → single column */
  .dataseo-grid {
    grid-template-columns: 1fr !important;
  }
}

/* ================================================================
   RESPONSIVE — 480 px (phone)
   ================================================================ */

@media (max-width: 480px) {
  /* Header — tighten further */
  .header-content {
    padding: 8px 12px;
  }
  .logo-img {
    height: 28px;
  }
  .logo span {
    display: none; /* show logo image only, hide text on phone */
  }

  /* Sticky offsets — corrected header offset for phone (~44px tall) */
  .sticky-tab-strip,
  .agent-back-strip {
    top: 44px;
  }

  /* Agent cards — single column */
  .card-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
  .agent-card {
    padding: 18px;
  }

  /* Tab strip — icon-only on phone to save space */
  .tab-label {
    display: none;
  }
  .tab-strip {
    flex-shrink: 0;
  }
  .tab-btn {
    white-space: nowrap;
    flex-shrink: 0;
    padding: 8px 12px;
    font-size: 11px;
  }

  /* Execution history — stack action buttons vertically on phone */
  .exec-actions {
    flex-direction: column;
    align-items: stretch;
    gap: 4px;
  }
  .exec-actions .btn-small {
    text-align: center;
    padding: 6px 10px;
  }

  /* Tighter table cells on phone */
  .table th,
  .table td {
    padding: 10px 10px;
  }
  .table th:first-child,
  .table td:first-child {
    padding-left: 12px;
  }

  /* Chat form — full-width stack */
  .chat-form-row {
    flex-direction: column;
    align-items: stretch;
  }
  .chat-form-row > div {
    flex: 1 1 100% !important;
    min-width: unset !important;
  }
  .chat-form-row .run-analysis-btn {
    width: 100%;
    height: 44px;
    margin-top: 2px;
  }

  /* Terminal window height on phone */
  .terminal-body {
    height: 220px;
  }

  /* Modal body padding */
  .modal-body {
    padding: 18px 16px;
  }
  .modal-header {
    padding: 16px;
  }
  .modal-footer {
    padding: 14px 16px;
  }

  /* Spinner center */
  .spinner-center {
    padding: 40px 16px;
  }
}

.settings-layout select {
  color: #fff !important;
}

.settings-layout select option {
  color: #000 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/App.css"],"names":[],"mappings":"AAAA;;qEAEqE;;AAErE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;EACxB,uCAAuC;;EAEvC,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,oCAAoC;EACpC,2CAA2C;;EAE3C,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,iCAAiC;EACjC,uCAAuC;EACvC,iCAAiC;EACjC,iCAAiC;;EAEjC,YAAY;EACZ,mCAAmC;EACnC,uCAAuC;EACvC,uCAAuC;;EAEvC,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;;EAEvB,kBAAkB;EAClB,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,qCAAqC;EACrC,0CAA0C;EAC1C,iBAAiB;EACjB,mCAAmC;EACnC,wCAAwC;EACxC,eAAe;EACf,kCAAkC;EAClC,uCAAuC;;EAEvC,cAAc;EACd,mEAAmE;EACnE,0DAA0D;EAC1D,iEAAiE;;EAEjE,YAAY;EACZ,0CAA0C;EAC1C,2CAA2C;EAC3C,4CAA4C;EAC5C,oDAAoD;;EAEpD,iDAAiD;EACjD,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;;EAEvB,6CAA6C;EAC7C,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;;qEAEqE;;AAErE;;;EAGE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE;;;;;;cAMY;EACZ,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;EACnC,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;qEAEqE;;AAErE;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR;;;;;;;;;;;;;;;KAeG;EACH,oBAAoB;EACpB,UAAU;EACV,yDAAyD;AAC3D;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR;;2EAEyE;EACzE,0BAA0B;EAC1B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;qEAEqE;;AAErE;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,mBAAmB;;EAEnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,8BAA8B;AAChC;;AAEA;;qEAEqE;;AAErE;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,sCAAsC;EACtC,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ;;kCAEgC;AAClC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,oEAAoE;AACtE;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;EACjC,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;qEAEqE;;AAErE;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,kDAAkD;EAClD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,cAAc;AAChB;;AAEA;;qEAEqE;;AAErE;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;AACf;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;;EAGE,iCAAiC;EACjC;;6BAE2B;EAC3B,iCAAiC;AACnC;;AAEA;;qEAEqE;;AAErE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,iDAAiD;EACjD,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,qDAAqD;EACrD,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;;AAEA;;qEAEqE;;AAErE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,0BAA0B;EAC1B,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mCAAmC;EACnC,yBAAyB;EACzB,yCAAyC;EACzC,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;qEAEqE;;AAErE;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mBAAmB;AACrB;;AAEA;;qEAEqE;;AAErE;EACE,eAAe;EACf,QAAQ;EACR,+BAA+B;EAC/B,2BAA2B;EAC3B,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,mBAAmB;EACnB;;oCAEkC;EAClC,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,yDAAyD;EACzD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;;GAMC;EACD,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,0BAA0B;EAC1B,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,cAAc;AAChB;;AAEA;;qEAEqE;;AAErE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,oCAAoC;EACpC,kBAAkB;EAClB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,oCAAoC;EACpC,2CAA2C;EAC3C,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE;IACE,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,UAAU;IACV,qBAAqB;EACvB;AACF;;AAEA;;qEAEqE;;AAErE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,mCAAmC;AACrC;AACA;EACE,4BAA4B;EAC5B,cAAc;EACd,kCAAkC;AACpC;AACA;EACE,0BAA0B;EAC1B,cAAc;EACd,gCAAgC;AAClC;;AAEA;;qEAEqE;;AAErE;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,sCAAsC;EACtC,mDAAmD;AACrD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;EACxC,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;qEAEqE;;AAErE;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,uDAAuD;AACzD;;AAEA;EACE;IACE,mCAAmC;EACrC;EACA;IACE,6CAA6C;EAC/C;AACF;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB;;oCAEkC;EAClC,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;;;;GAMC;EACD,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;EACnC,wCAAwC;EACxC,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,8BAA8B;EAC9B,sCAAsC;EACtC,iDAAiD;AACnD;;AAEA;EACE;;IAEE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA;;qEAEqE;;AAErE;EACE,oBAAoB;EACpB,QAAQ;EACR,qCAAqC;EACrC,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;EAC5B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;;qEAEqE;;AAErE;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,mCAAmC;EACnC,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,kDAAkD;EAClD,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,0EAA0E;EAC1E,oBAAoB;EACpB,UAAU;EACV,8BAA8B;AAChC;;AAEA;EACE,qCAAqC;EACrC;;mCAEiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,iBAAiB;EACjB,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mCAAmC;EACnC,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;qEAEqE;;AAErE;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,sEAAsE;AACxE;;AAEA;;qEAEqE;;AAErE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;qEAEqE;;AAErE;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,wCAAwC;EACxC,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;qEAEqE;;AAErE;EACE,qBAAqB;EACrB,sDAAsD;AACxD;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,uBAAuB;AACzB;AACA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,qCAAqC;AACvC;;AAEA;;qEAEqE;;AAErE;EACE,kBAAkB;AACpB;AACA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,SAAS;AACX;AACA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;;AAEA;;qEAEqE;;AAErE,yCAAyC;AACzC;EACE,gBAAgB;EAChB,iCAAiC;EACjC,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA,2DAA2D;AAC3D;;EAEE,WAAW;EACX,sBAAsB;AACxB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;;qEAEqE;;AAErE;EACE,mCAAmC;EACnC,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;;qEAEqE;;AAErE;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA;;qEAEqE;;AAErE;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;AACV;;AAEA,6CAA6C;AAC7C;EACE,uBAAuB;AACzB;;AAEA;;qEAEqE;;AAErE;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;AACnB;;AAEA;;qEAEqE;;AAErE;EACE,WAAW;EACX;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA,iCAAiC;EACjC;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,YAAY;IACZ,SAAS;EACX;EACA;IACE,eAAe;EACjB;EACA;IACE,aAAa;EACf;EACA,0DAA0D;EAC1D;;IAEE,aAAa;EACf;;EAEA,qEAAqE;EACrE;;IAEE,SAAS;EACX;;EAEA,oEAAoE;EACpE;IACE,aAAa;EACf;;EAEA,sDAAsD;EACtD;IACE,eAAe;IACf,QAAQ;EACV;;EAEA,gBAAgB;EAChB;IACE,4DAA4D;IAC5D,SAAS;EACX;;EAEA,UAAU;EACV;IACE,UAAU;IACV,2BAA2B;IAC3B,mBAAmB;EACrB;;EAEA,cAAc;EACd;IACE,mBAAmB;EACrB;EACA;IACE,iBAAiB;IACjB,eAAe;EACjB;;EAEA,UAAU;EACV;IACE,kBAAkB;IAClB,YAAY;EACd;;EAEA,wCAAwC;EACxC;IACE,sBAAsB;IACtB,SAAS;EACX;EACA;IACE,WAAW;EACb;;EAEA,mDAAmD;EACnD;IACE,gDAAgD;EAClD;;EAEA,gDAAgD;EAChD;IACE,mBAAmB;EACrB;EACA,yCAAyC;EACzC;IACE,aAAa;EACf;;EAEA,WAAW;EACX;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;IACR,eAAe;EACjB;;EAEA,+CAA+C;EAC/C;IACE,qCAAqC;EACvC;AACF;;AAEA;;qEAEqE;;AAErE;EACE,6BAA6B;EAC7B;IACE,iBAAiB;EACnB;EACA;IACE,YAAY;EACd;EACA;IACE,aAAa,EAAE,6CAA6C;EAC9D;;EAEA,oEAAoE;EACpE;;IAEE,SAAS;EACX;;EAEA,gCAAgC;EAChC;IACE,0BAA0B;IAC1B,SAAS;EACX;EACA;IACE,aAAa;EACf;;EAEA,iDAAiD;EACjD;IACE,aAAa;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,eAAe;EACjB;;EAEA,iEAAiE;EACjE;IACE,sBAAsB;IACtB,oBAAoB;IACpB,QAAQ;EACV;EACA;IACE,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA,iCAAiC;EACjC;;IAEE,kBAAkB;EACpB;EACA;;IAEE,kBAAkB;EACpB;;EAEA,iCAAiC;EACjC;IACE,sBAAsB;IACtB,oBAAoB;EACtB;EACA;IACE,yBAAyB;IACzB,2BAA2B;EAC7B;EACA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA,oCAAoC;EACpC;IACE,aAAa;EACf;;EAEA,uBAAuB;EACvB;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;EACpB;;EAEA,mBAAmB;EACnB;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB","sourcesContent":["/* ================================================================\n   SAFFRON OS – ORGANIC SEARCH WITH AI, GEO ETC  |  Modern AI-Native Design System\n   ================================================================ */\n\n:root {\n  /* Brand palette */\n  --saffron: #f59e0b;\n  --saffron-light: #fbbf24;\n  --saffron-glow: rgba(245, 158, 11, 0.2);\n\n  /* Teal accents */\n  --teal: #0891b2;\n  --teal-bright: #06b6d4;\n  --teal-glow: rgba(6, 182, 212, 0.18);\n  --teal-glow-strong: rgba(6, 182, 212, 0.35);\n\n  /* Backgrounds */\n  --bg-base: #08111f;\n  --bg-elevated: #0d1829;\n  --bg-card: rgba(13, 24, 41, 0.82);\n  --bg-card-hover: rgba(13, 24, 41, 0.97);\n  --bg-input: rgba(8, 17, 31, 0.75);\n  --bg-overlay: rgba(0, 0, 0, 0.72);\n\n  /* Borders */\n  --border: rgba(255, 255, 255, 0.07);\n  --border-hover: rgba(6, 182, 212, 0.32);\n  --border-focus: rgba(6, 182, 212, 0.55);\n\n  /* Text */\n  --text: #e2e8f0;\n  --text-secondary: #94a3b8;\n  --text-muted: #64748b;\n  --text-heading: #f8fafc;\n\n  /* Status colors */\n  --success: #10b981;\n  --success-bg: rgba(16, 185, 129, 0.1);\n  --success-border: rgba(16, 185, 129, 0.28);\n  --warning: #f59e0b;\n  --warning-bg: rgba(245, 158, 11, 0.1);\n  --warning-border: rgba(245, 158, 11, 0.28);\n  --danger: #ef4444;\n  --danger-bg: rgba(239, 68, 68, 0.1);\n  --danger-border: rgba(239, 68, 68, 0.28);\n  --info: #3b82f6;\n  --info-bg: rgba(59, 130, 246, 0.1);\n  --info-border: rgba(59, 130, 246, 0.28);\n\n  /* Gradients */\n  --gradient-brand: linear-gradient(135deg, #06b6d4 0%, #f59e0b 100%);\n  --gradient-teal: linear-gradient(135deg, #0891b2, #06b6d4);\n  --gradient-btn: linear-gradient(135deg, #0891b2 0%, #0e7490 100%);\n\n  /* Shadows */\n  --shadow-sm: 0 2px 8px rgba(0, 0, 0, 0.35);\n  --shadow-md: 0 4px 24px rgba(0, 0, 0, 0.45);\n  --shadow-lg: 0 12px 48px rgba(0, 0, 0, 0.55);\n  --shadow-glow-teal: 0 0 24px rgba(6, 182, 212, 0.12);\n\n  /* Surface — used for cards, list items, panels */\n  --surface: #0d1829;\n  --bg: var(--bg-base);\n  --text-primary: #f8fafc;\n\n  /* Legacy compat aliases used inline in JSX */\n  --primary: #0891b2;\n  --primary-light: #06b6d4;\n  --secondary: #06b6d4;\n  --light: #e2e8f0;\n  --lighter: rgba(255, 255, 255, 0.04);\n  --dark: #f8fafc;\n}\n\n/* ================================================================\n   RESET & BASE\n   ================================================================ */\n\n*,\n*::before,\n*::after {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\nhtml {\n  scroll-behavior: smooth;\n}\n\nbody {\n  font-family:\n    \"Inter\",\n    -apple-system,\n    BlinkMacSystemFont,\n    \"Segoe UI\",\n    Roboto,\n    sans-serif;\n  background-color: var(--bg-base);\n  color: var(--text);\n  line-height: 1.6;\n  -webkit-font-smoothing: antialiased;\n  min-height: 100vh;\n  overflow-x: hidden;\n}\n\n/* ================================================================\n   ATMOSPHERIC BACKGROUND\n   ================================================================ */\n\nbody::before {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  background:\n    radial-gradient(\n      ellipse 90% 55% at 15% 25%,\n      rgba(6, 182, 212, 0.055) 0%,\n      transparent 65%\n    ),\n    radial-gradient(\n      ellipse 65% 45% at 85% 75%,\n      rgba(245, 158, 11, 0.045) 0%,\n      transparent 65%\n    ),\n    radial-gradient(\n      ellipse 110% 80% at 50% 5%,\n      rgba(8, 145, 178, 0.035) 0%,\n      transparent 70%\n    );\n  pointer-events: none;\n  z-index: 0;\n  animation: atmos-drift 20s ease-in-out infinite alternate;\n}\n\n@keyframes atmos-drift {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\nbody::after {\n  content: \"\";\n  position: fixed;\n  inset: 0;\n  background-image:\n    linear-gradient(rgba(255, 255, 255, 0.022) 1px, transparent 1px),\n    linear-gradient(90deg, rgba(255, 255, 255, 0.022) 1px, transparent 1px);\n  background-size: 44px 44px;\n  pointer-events: none;\n  z-index: 0;\n}\n\n#root {\n  position: relative;\n  z-index: 1;\n}\n\n/* ================================================================\n   LAYOUT\n   ================================================================ */\n\n.container {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 28px;\n}\n\n.dashboard-description {\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  padding: 0;\n  margin-bottom: 20px;\n\n  font-size: 12px;\n  line-height: 1.7;\n  color: rgb(167, 167, 167);\n  font-weight: 100;\n}\n\n.full-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.page {\n  padding: 36px 0;\n  min-height: calc(100vh - 68px);\n}\n\n/* ================================================================\n   HEADER\n   ================================================================ */\n\n.header {\n  background: rgba(8, 17, 31, 0.88);\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  border-bottom: 1px solid var(--border);\n  padding: 0;\n  height: 68px;\n  position: sticky;\n  top: 0;\n  z-index: 200;\n  box-shadow:\n    0 1px 0 rgba(255, 255, 255, 0.04),\n    0 4px 32px rgba(0, 0, 0, 0.35);\n}\n\n.header-content {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 28px;\n  height: 100%;\n}\n\n.logo {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  text-decoration: none;\n}\n\n.logo-img {\n  height: 36px;\n  width: auto;\n  filter: brightness(1.1) drop-shadow(0 0 8px rgba(6, 182, 212, 0.25));\n}\n\n.logo span {\n  font-size: 15px;\n  font-weight: 700;\n  letter-spacing: -0.01em;\n  background: var(--gradient-brand);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.user-info {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n}\n\n.user-info > span {\n  font-size: 13px;\n  color: var(--text-secondary);\n  font-weight: 500;\n}\n\n/* Mobile three-dot menu — hidden on desktop */\n.mobile-menu-wrap {\n  display: none;\n  position: relative;\n}\n\n.mobile-menu-btn {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  width: 36px;\n  height: 36px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  cursor: pointer;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.mobile-menu-btn span {\n  display: block;\n  width: 4px;\n  height: 4px;\n  border-radius: 50%;\n  background: var(--text-secondary);\n}\n\n.mobile-menu-dropdown {\n  position: absolute;\n  top: calc(100% + 8px);\n  right: 0;\n  min-width: 200px;\n  background: rgba(8, 17, 31, 0.98);\n  backdrop-filter: blur(24px);\n  -webkit-backdrop-filter: blur(24px);\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n  z-index: 300;\n}\n\n.mobile-menu-user {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--border);\n}\n\n.mobile-menu-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--gradient-btn);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: 700;\n  color: white;\n  flex-shrink: 0;\n}\n\n.mobile-menu-username {\n  font-size: 13px;\n  font-weight: 500;\n  color: var(--text-secondary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.mobile-menu-signout {\n  display: block;\n  width: 100%;\n  padding: 12px 16px;\n  text-align: left;\n  font-size: 13px;\n  font-weight: 500;\n  color: #f87171;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.mobile-menu-signout:hover {\n  background: rgba(239, 68, 68, 0.08);\n}\n\n/* ================================================================\n   CARDS & PANELS\n   ================================================================ */\n\n.card {\n  background: var(--bg-card);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  padding: 24px;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.card:hover {\n  background: var(--bg-card-hover);\n  border-color: var(--border-hover);\n  box-shadow: var(--shadow-md), var(--shadow-glow-teal);\n  transform: translateY(-2px);\n}\n\n.card-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));\n  gap: 20px;\n  margin: 20px 0;\n}\n\n/* ================================================================\n   FORMS\n   ================================================================ */\n\n.form-group {\n  margin-bottom: 18px;\n}\n\n.form-group label {\n  display: block;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n  margin-bottom: 8px;\n}\n\n.form-group input,\n.form-group select,\n.form-group textarea {\n  width: 100%;\n  padding: 11px 14px;\n  background: var(--bg-input);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: \"Inter\", inherit;\n  color: var(--text);\n  transition: all 0.2s ease;\n  outline: none;\n}\n\n.form-group input::placeholder,\n.form-group textarea::placeholder {\n  color: var(--text-muted);\n}\n\n.form-group select option {\n  background: var(--bg-elevated);\n  color: var(--text);\n}\n\n.form-group input:focus,\n.form-group select:focus,\n.form-group textarea:focus {\n  border-color: var(--border-focus);\n  box-shadow:\n    0 0 0 3px var(--teal-glow),\n    0 0 16px var(--teal-glow);\n  background: rgba(8, 17, 31, 0.92);\n}\n\n/* ================================================================\n   BUTTONS\n   ================================================================ */\n\n.btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 7px;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  font-family: \"Inter\", inherit;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  text-decoration: none;\n  position: relative;\n  overflow: hidden;\n  white-space: nowrap;\n  letter-spacing: 0.01em;\n}\n\n.btn:active {\n  transform: scale(0.97);\n}\n.btn:disabled {\n  opacity: 0.42;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n.btn-primary {\n  background: var(--gradient-btn);\n  color: white;\n  box-shadow: 0 2px 14px rgba(8, 145, 178, 0.28);\n}\n\n.btn-primary:hover:not(:disabled) {\n  box-shadow: 0 4px 22px rgba(6, 182, 212, 0.42);\n  transform: translateY(-1px);\n}\n\n.btn-secondary {\n  background: linear-gradient(135deg, #0891b2, #06b6d4);\n  color: white;\n  box-shadow: 0 2px 14px rgba(6, 182, 212, 0.22);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  box-shadow: 0 4px 22px rgba(6, 182, 212, 0.42);\n  transform: translateY(-1px);\n}\n\n.btn-success {\n  background: linear-gradient(135deg, #059669, #10b981);\n  color: white;\n}\n\n.btn-danger {\n  background: linear-gradient(135deg, #dc2626, #ef4444);\n  color: white;\n}\n\n.btn-small {\n  padding: 6px 12px;\n  font-size: 12px;\n  border-radius: 6px;\n}\n.btn-full {\n  width: 100%;\n}\n\n/* ================================================================\n   BADGES\n   ================================================================ */\n\n.badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 3px 10px;\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n\n.badge-success {\n  background: var(--success-bg);\n  color: #34d399;\n  border: 1px solid var(--success-border);\n}\n\n.badge-warning {\n  background: var(--warning-bg);\n  color: #fbbf24;\n  border: 1px solid var(--warning-border);\n}\n\n.badge-danger {\n  background: var(--danger-bg);\n  color: #f87171;\n  border: 1px solid var(--danger-border);\n}\n\n.badge-info {\n  background: var(--info-bg);\n  color: #60a5fa;\n  border: 1px solid var(--info-border);\n}\n\n.badge-category {\n  display: inline-flex;\n  align-items: center;\n  gap: 5px;\n  background: rgba(6, 182, 212, 0.08);\n  color: var(--teal-bright);\n  border: 1px solid rgba(6, 182, 212, 0.18);\n  padding: 3px 10px;\n  border-radius: 6px;\n  font-size: 11px;\n  font-weight: 500;\n  margin-top: 8px;\n}\n\n/* ================================================================\n   TABLES\n   ================================================================ */\n\n.table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  margin: 12px 0;\n}\n\n.table th {\n  background: rgba(255, 255, 255, 0.025);\n  padding: 12px 16px;\n  text-align: left;\n  font-size: 10px;\n  font-weight: 700;\n  letter-spacing: 0.09em;\n  text-transform: uppercase;\n  color: var(--text-secondary);\n  border-bottom: 1px solid var(--border);\n}\n\n.table td {\n  padding: 14px 16px;\n  border-bottom: 1px solid var(--border);\n  font-size: 13px;\n  color: var(--text);\n  vertical-align: middle;\n}\n\n.table tbody tr {\n  transition: background 0.15s ease;\n}\n.table tbody tr:hover {\n  background: rgba(6, 182, 212, 0.04);\n}\n.table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* ================================================================\n   MODAL\n   ================================================================ */\n\n.modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.72);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  animation: fadeIn 0.18s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.modal {\n  background: rgba(8, 17, 31, 0.97);\n  backdrop-filter: blur(28px);\n  -webkit-backdrop-filter: blur(28px);\n  border: 1px solid var(--border);\n  border-radius: 18px;\n  box-shadow:\n    var(--shadow-lg),\n    0 0 80px rgba(6, 182, 212, 0.07);\n  max-width: 560px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  animation: slideUp 0.28s cubic-bezier(0.34, 1.4, 0.64, 1);\n  position: relative;\n}\n\n.modal::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(6, 182, 212, 0.5),\n    rgba(245, 158, 11, 0.35),\n    transparent\n  );\n  border-radius: 18px 18px 0 0;\n  z-index: 1;\n}\n\n@keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(24px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.modal-header {\n  padding: 22px 26px;\n  border-bottom: 1px solid var(--border);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.modal-header h2 {\n  font-size: 17px;\n  font-weight: 600;\n  color: var(--text-heading);\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.modal-body {\n  padding: 26px;\n}\n\n.modal-footer {\n  padding: 18px 26px;\n  border-top: 1px solid var(--border);\n  display: flex;\n  gap: 10px;\n  justify-content: flex-end;\n  background: rgba(0, 0, 0, 0.18);\n  border-radius: 0 0 18px 18px;\n}\n\n.close-btn {\n  background: rgba(255, 255, 255, 0.055);\n  border: 1px solid var(--border);\n  border-radius: 7px;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 15px;\n  cursor: pointer;\n  color: var(--text-secondary);\n  transition: all 0.15s ease;\n  line-height: 1;\n  flex-shrink: 0;\n}\n\n.close-btn:hover {\n  background: rgba(239, 68, 68, 0.14);\n  border-color: rgba(239, 68, 68, 0.3);\n  color: #f87171;\n}\n\n/* ================================================================\n   STATUS INDICATORS\n   ================================================================ */\n\n.status-container {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  padding: 16px 20px;\n  background: rgba(6, 182, 212, 0.05);\n  border: 1px solid rgba(6, 182, 212, 0.14);\n  border-radius: 10px;\n  margin: 15px 0;\n}\n\n.spinner {\n  width: 20px;\n  height: 20px;\n  border: 2px solid rgba(6, 182, 212, 0.14);\n  border-top-color: var(--teal-bright);\n  border-radius: 50%;\n  animation: spin 0.75s linear infinite;\n  flex-shrink: 0;\n}\n\n.spinner-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 64px;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.spinner-lg {\n  width: 42px;\n  height: 42px;\n  border: 3px solid rgba(6, 182, 212, 0.1);\n  border-top-color: var(--teal-bright);\n  border-right-color: rgba(6, 182, 212, 0.45);\n  border-radius: 50%;\n  animation: spin 0.9s linear infinite;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.pulse-dot {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: var(--teal-bright);\n  position: relative;\n  flex-shrink: 0;\n  box-shadow: 0 0 8px var(--teal-bright);\n}\n\n.pulse-dot::after {\n  content: \"\";\n  position: absolute;\n  inset: -5px;\n  border-radius: 50%;\n  border: 2px solid var(--teal-bright);\n  animation: pulse-ring 1.6s ease-out infinite;\n}\n\n@keyframes pulse-ring {\n  0% {\n    opacity: 0.8;\n    transform: scale(1);\n  }\n  100% {\n    opacity: 0;\n    transform: scale(2.2);\n  }\n}\n\n/* ================================================================\n   ALERTS\n   ================================================================ */\n\n.alert {\n  padding: 12px 16px;\n  border-radius: 8px;\n  margin-bottom: 16px;\n  font-size: 13px;\n  font-weight: 500;\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  border: 1px solid;\n}\n\n.alert-success {\n  background: var(--success-bg);\n  color: #34d399;\n  border-color: var(--success-border);\n}\n.alert-error {\n  background: var(--danger-bg);\n  color: #f87171;\n  border-color: var(--danger-border);\n}\n.alert-info {\n  background: var(--info-bg);\n  color: #60a5fa;\n  border-color: var(--info-border);\n}\n\n/* ================================================================\n   TERMINAL WINDOW\n   ================================================================ */\n\n.terminal-window {\n  background: #020c18;\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  border-radius: 12px;\n  overflow: hidden;\n  margin-bottom: 16px;\n}\n\n.terminal-chrome {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 10px 14px;\n  background: rgba(255, 255, 255, 0.025);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.055);\n}\n\n.term-dot {\n  width: 11px;\n  height: 11px;\n  border-radius: 50%;\n}\n.term-dot-red {\n  background: #ff5f57;\n}\n.term-dot-yellow {\n  background: #ffbd2e;\n}\n.term-dot-green {\n  background: #28c840;\n}\n\n.terminal-label {\n  margin-left: 8px;\n  font-size: 11px;\n  color: var(--text-muted);\n  font-family: \"JetBrains Mono\", monospace;\n}\n\n.terminal-body {\n  padding: 16px 18px;\n  font-family: \"JetBrains Mono\", monospace;\n  font-size: 12px;\n  height: 300px;\n  overflow-y: auto;\n  line-height: 1.75;\n  color: #c9d1d9;\n}\n\n.terminal-body::-webkit-scrollbar {\n  width: 4px;\n}\n.terminal-body::-webkit-scrollbar-track {\n  background: transparent;\n}\n.terminal-body::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 2px;\n}\n\n.log-stderr {\n  color: #f87171;\n}\n.log-stdout {\n  color: #c9d1d9;\n}\n.log-waiting {\n  color: var(--text-muted);\n  font-style: italic;\n}\n\n/* ================================================================\n   LOGIN PAGE\n   ================================================================ */\n\n.login-orb {\n  position: absolute;\n  border-radius: 50%;\n  filter: blur(90px);\n  pointer-events: none;\n  animation: orb-drift 10s ease-in-out infinite alternate;\n}\n\n@keyframes orb-drift {\n  0% {\n    transform: translate(0, 0) scale(1);\n  }\n  100% {\n    transform: translate(18px, -22px) scale(1.08);\n  }\n}\n\n.login-card {\n  background: rgba(8, 17, 31, 0.88);\n  backdrop-filter: blur(36px);\n  -webkit-backdrop-filter: blur(36px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 22px;\n  padding: 44px 40px 40px;\n  width: 100%;\n  max-width: 430px;\n  position: relative;\n  box-shadow:\n    0 28px 80px rgba(0, 0, 0, 0.6),\n    0 0 50px rgba(6, 182, 212, 0.06);\n  animation: slideUp 0.38s cubic-bezier(0.34, 1.3, 0.64, 1);\n}\n\n.login-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 1px;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(6, 182, 212, 0.55),\n    rgba(245, 158, 11, 0.42),\n    transparent\n  );\n  border-radius: 22px 22px 0 0;\n}\n\n.login-ai-badge {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  padding: 5px 14px;\n  background: rgba(6, 182, 212, 0.08);\n  border: 1px solid rgba(6, 182, 212, 0.2);\n  border-radius: 20px;\n  font-size: 11px;\n  font-weight: 700;\n  color: var(--teal-bright);\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  margin-bottom: 22px;\n}\n\n.login-ai-badge::before {\n  content: \"\";\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  background: var(--teal-bright);\n  box-shadow: 0 0 6px var(--teal-bright);\n  animation: pulse-dot-anim 2s ease-in-out infinite;\n}\n\n@keyframes pulse-dot-anim {\n  0%,\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.5;\n    transform: scale(0.75);\n  }\n}\n\n/* ================================================================\n   DASHBOARD TABS\n   ================================================================ */\n\n.tab-strip {\n  display: inline-flex;\n  gap: 3px;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  padding: 4px;\n  margin-bottom: 36px;\n}\n\n.tab-btn {\n  padding: 8px 22px;\n  border: none;\n  background: transparent;\n  border-radius: 7px;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: \"Inter\", inherit;\n  color: var(--text-secondary);\n  transition: all 0.2s ease;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  letter-spacing: 0.01em;\n}\n\n.tab-btn:hover {\n  color: var(--text);\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.tab-btn.tab-active {\n  background: var(--gradient-btn);\n  color: white;\n  box-shadow: 0 2px 14px rgba(8, 145, 178, 0.3);\n}\n\n/* ================================================================\n   AGENT CARDS\n   ================================================================ */\n\n.agent-card {\n  background: var(--bg-card);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  padding: 24px;\n  cursor: pointer;\n  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n}\n\n.agent-card::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  height: 70px;\n  background: linear-gradient(to top, rgba(6, 182, 212, 0.045), transparent);\n  pointer-events: none;\n  opacity: 0;\n  transition: opacity 0.25s ease;\n}\n\n.agent-card:hover {\n  border-color: rgba(6, 182, 212, 0.24);\n  box-shadow:\n    var(--shadow-md),\n    0 0 28px rgba(6, 182, 212, 0.1);\n  transform: translateY(-3px);\n}\n\n.agent-card:hover::after {\n  opacity: 1;\n}\n\n.agent-icon-wrap {\n  width: 50px;\n  height: 50px;\n  border-radius: 13px;\n  background: rgba(6, 182, 212, 0.08);\n  border: 1px solid rgba(6, 182, 212, 0.14);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 26px;\n  margin-bottom: 18px;\n  transition: all 0.25s ease;\n  flex-shrink: 0;\n}\n\n.agent-card:hover .agent-icon-wrap {\n  background: rgba(6, 182, 212, 0.14);\n  border-color: rgba(6, 182, 212, 0.32);\n  box-shadow: 0 0 18px rgba(6, 182, 212, 0.14);\n}\n\n.agent-name {\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--text-heading);\n  margin-bottom: 8px;\n  line-height: 1.3;\n}\n\n.agent-desc {\n  font-size: 13px;\n  color: var(--text-secondary);\n  line-height: 1.65;\n  margin-bottom: 18px;\n  flex: 1;\n}\n\n.agent-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding-top: 16px;\n  border-top: 1px solid var(--border);\n  margin-top: auto;\n  position: relative;\n  z-index: 1;\n}\n\n.agent-launch-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 7px 14px;\n  background: rgba(6, 182, 212, 0.09);\n  border: 1px solid rgba(6, 182, 212, 0.2);\n  border-radius: 7px;\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--teal-bright);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: \"Inter\", inherit;\n  letter-spacing: 0.01em;\n}\n\n.agent-launch-btn:hover {\n  background: rgba(6, 182, 212, 0.18);\n  border-color: rgba(6, 182, 212, 0.4);\n  box-shadow: 0 0 14px rgba(6, 182, 212, 0.15);\n}\n\n.btn-arrow {\n  display: inline-block;\n  transition: transform 0.2s ease;\n}\n\n.agent-card:hover .btn-arrow {\n  transform: translateX(3px);\n}\n\n/* ================================================================\n   CATEGORY HEADER\n   ================================================================ */\n\n.category-header {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  margin-bottom: 20px;\n}\n\n.category-label {\n  font-size: 10px;\n  font-weight: 800;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n  color: var(--text-muted);\n  white-space: nowrap;\n}\n\n.category-sep {\n  flex: 1;\n  height: 1px;\n  background: linear-gradient(90deg, var(--border) 0%, transparent 100%);\n}\n\n/* ================================================================\n   EMPTY STATE\n   ================================================================ */\n\n.empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 80px 20px;\n  text-align: center;\n  gap: 10px;\n}\n\n.empty-state-icon {\n  font-size: 44px;\n  opacity: 0.45;\n  margin-bottom: 6px;\n}\n.empty-state-title {\n  font-size: 18px;\n  font-weight: 600;\n  color: var(--text);\n}\n.empty-state-desc {\n  font-size: 14px;\n  color: var(--text-secondary);\n  max-width: 320px;\n}\n\n/* ================================================================\n   RESULTS OUTPUT\n   ================================================================ */\n\n.results-output {\n  background: #020c18;\n  border: 1px solid rgba(255, 255, 255, 0.07);\n  border-radius: 10px;\n  padding: 18px 20px;\n  max-height: 430px;\n  overflow: auto;\n  font-family: \"JetBrains Mono\", monospace;\n  font-size: 12.5px;\n  line-height: 1.75;\n  color: #c9d1d9;\n  white-space: pre-wrap;\n  word-break: break-word;\n  margin-bottom: 20px;\n}\n\n/* ================================================================\n   SCROLLBAR\n   ================================================================ */\n\n* {\n  scrollbar-width: thin;\n  scrollbar-color: rgba(255, 255, 255, 0.08) transparent;\n}\n*::-webkit-scrollbar {\n  width: 5px;\n  height: 5px;\n}\n*::-webkit-scrollbar-track {\n  background: transparent;\n}\n*::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.09);\n  border-radius: 3px;\n}\n*::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.18);\n}\n\n/* ================================================================\n   UTILITY CLASSES\n   ================================================================ */\n\n.text-center {\n  text-align: center;\n}\n.text-muted {\n  color: var(--text-muted);\n}\n\n.mb-1 {\n  margin-bottom: 10px;\n}\n.mb-2 {\n  margin-bottom: 20px;\n}\n.mb-3 {\n  margin-bottom: 30px;\n}\n.mt-1 {\n  margin-top: 10px;\n}\n.mt-2 {\n  margin-top: 20px;\n}\n.gap-1 {\n  gap: 10px;\n}\n.gap-2 {\n  gap: 20px;\n}\n\n.flex {\n  display: flex;\n}\n.flex-center {\n  display: flex;\n  align-items: center;\n}\n.flex-between {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n.flex-col {\n  display: flex;\n  flex-direction: column;\n}\n\n.p-3 {\n  padding: 20px;\n}\n.p-4 {\n  padding: 30px;\n}\n\n/* ================================================================\n   RESPONSIVE HELPERS (used by components)\n   ================================================================ */\n\n/* Horizontal-scroll wrapper for tables */\n.table-responsive {\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  border-radius: 14px;\n}\n\n/* Chat input row — flexes on desktop, stacks on mobile */\n.chat-form-row {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n/* Inputs inside the form row always fill their container */\n.chat-form-row input,\n.chat-form-row select {\n  width: 100%;\n  box-sizing: border-box;\n}\n\n/* Settings two-column layout */\n.settings-layout {\n  display: flex;\n  gap: 28px;\n  align-items: flex-start;\n}\n.settings-sidebar {\n  width: 220px;\n  flex-shrink: 0;\n}\n\n/* ================================================================\n   SITE FOOTER\n   ================================================================ */\n\n.site-footer {\n  border-top: 1px solid var(--border);\n  background: rgba(8, 17, 31, 0.72);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  padding: 18px 0;\n  margin-top: 48px;\n}\n\n.site-footer-inner {\n  max-width: 1280px;\n  margin: 0 auto;\n  padding: 0 28px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.site-footer-copy {\n  font-size: 12px;\n  color: var(--text-muted);\n  font-weight: 400;\n}\n\n.site-footer-links {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.site-footer-link {\n  font-size: 12px;\n  color: var(--text-muted);\n  text-decoration: none;\n  font-weight: 500;\n  transition: color 0.15s ease;\n}\n\n.site-footer-link:hover {\n  color: var(--teal-bright);\n}\n\n.site-footer-sep {\n  color: var(--border);\n  font-size: 12px;\n  user-select: none;\n}\n\n/* ================================================================\n   AGENT PAGE — STICKY BACK BUTTON STRIP\n   ================================================================ */\n\n.agent-back-strip {\n  position: sticky;\n  top: 68px;\n  z-index: 100;\n}\n\n/* ================================================================\n   STICKY TAB STRIP + TAB ROW LAYOUT\n   ================================================================ */\n\n.sticky-tab-strip {\n  position: sticky;\n  top: 68px;\n  z-index: 150;\n  padding-top: 12px;\n}\n\n.tab-strip-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Tab text label — hidden on narrow phones */\n.tab-label {\n  /* visible by default */\n}\n\n/* ================================================================\n   EXECUTION HISTORY — ACTION BUTTON GROUP\n   ================================================================ */\n\n.exec-actions {\n  display: flex;\n  gap: 6px;\n  flex-wrap: nowrap;\n}\n\n/* ================================================================\n   RESPONSIVE — 768 px (tablet / large mobile)\n   ================================================================ */\n\n@media (max-width: 768px) {\n  /* Layout */\n  .container {\n    padding: 0 14px;\n  }\n  .page {\n    padding: 18px 0;\n  }\n\n  /* Header — single row, compact */\n  .header {\n    height: auto;\n  }\n  .header-content {\n    padding: 10px 14px;\n    height: auto;\n    gap: 10px;\n  }\n  .logo span {\n    font-size: 13px;\n  }\n  .header-logo-text {\n    display: none;\n  }\n  /* UserMenu — hide name text on tablet, keep avatar pill */\n  .user-menu-name,\n  .user-menu-chevron {\n    display: none;\n  }\n\n  /* Sticky offsets — corrected header offset for mobile (~56px tall) */\n  .sticky-tab-strip,\n  .agent-back-strip {\n    top: 56px;\n  }\n\n  /* Dashboard description — hidden on mobile to save vertical space */\n  .dashboard-description {\n    display: none;\n  }\n\n  /* Execution history action buttons — wrap at tablet */\n  .exec-actions {\n    flex-wrap: wrap;\n    gap: 5px;\n  }\n\n  /* Agent cards */\n  .card-grid {\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n    gap: 14px;\n  }\n\n  /* Modal */\n  .modal {\n    width: 96%;\n    min-width: unset !important;\n    border-radius: 14px;\n  }\n\n  /* Tab strip */\n  .tab-strip {\n    margin-bottom: 20px;\n  }\n  .tab-btn {\n    padding: 7px 14px;\n    font-size: 12px;\n  }\n\n  /* Login */\n  .login-card {\n    padding: 28px 20px;\n    margin: 12px;\n  }\n\n  /* Settings — stack sidebar above form */\n  .settings-layout {\n    flex-direction: column;\n    gap: 16px;\n  }\n  .settings-sidebar {\n    width: 100%;\n  }\n\n  /* Onboarding — drop the side rail below the form */\n  .onboarding-grid {\n    grid-template-columns: minmax(0, 1fr) !important;\n  }\n\n  /* Execution history table — horizontal scroll */\n  .table-responsive {\n    border-radius: 14px;\n  }\n  /* Hide less-critical columns on tablet */\n  .table-col-hide {\n    display: none;\n  }\n\n  /* Footer */\n  .site-footer-inner {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 8px;\n    padding: 0 14px;\n  }\n\n  /* DataForSEO credential grid → single column */\n  .dataseo-grid {\n    grid-template-columns: 1fr !important;\n  }\n}\n\n/* ================================================================\n   RESPONSIVE — 480 px (phone)\n   ================================================================ */\n\n@media (max-width: 480px) {\n  /* Header — tighten further */\n  .header-content {\n    padding: 8px 12px;\n  }\n  .logo-img {\n    height: 28px;\n  }\n  .logo span {\n    display: none; /* show logo image only, hide text on phone */\n  }\n\n  /* Sticky offsets — corrected header offset for phone (~44px tall) */\n  .sticky-tab-strip,\n  .agent-back-strip {\n    top: 44px;\n  }\n\n  /* Agent cards — single column */\n  .card-grid {\n    grid-template-columns: 1fr;\n    gap: 12px;\n  }\n  .agent-card {\n    padding: 18px;\n  }\n\n  /* Tab strip — icon-only on phone to save space */\n  .tab-label {\n    display: none;\n  }\n  .tab-strip {\n    flex-shrink: 0;\n  }\n  .tab-btn {\n    white-space: nowrap;\n    flex-shrink: 0;\n    padding: 8px 12px;\n    font-size: 11px;\n  }\n\n  /* Execution history — stack action buttons vertically on phone */\n  .exec-actions {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 4px;\n  }\n  .exec-actions .btn-small {\n    text-align: center;\n    padding: 6px 10px;\n  }\n\n  /* Tighter table cells on phone */\n  .table th,\n  .table td {\n    padding: 10px 10px;\n  }\n  .table th:first-child,\n  .table td:first-child {\n    padding-left: 12px;\n  }\n\n  /* Chat form — full-width stack */\n  .chat-form-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n  .chat-form-row > div {\n    flex: 1 1 100% !important;\n    min-width: unset !important;\n  }\n  .chat-form-row .run-analysis-btn {\n    width: 100%;\n    height: 44px;\n    margin-top: 2px;\n  }\n\n  /* Terminal window height on phone */\n  .terminal-body {\n    height: 220px;\n  }\n\n  /* Modal body padding */\n  .modal-body {\n    padding: 18px 16px;\n  }\n  .modal-header {\n    padding: 16px;\n  }\n  .modal-footer {\n    padding: 14px 16px;\n  }\n\n  /* Spinner center */\n  .spinner-center {\n    padding: 40px 16px;\n  }\n}\n\n.settings-layout select {\n  color: #fff !important;\n}\n\n.settings-layout select option {\n  color: #000 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
